import { normalizeSupportedLocale, type SupportedLocale } from "../profile/profileApi";
import productBrand from "./productBrand.json";

type ProductBrandConfig = {
  names: Record<SupportedLocale, string>;
  staticName: string;
};

const brandConfig = productBrand as ProductBrandConfig;

export const PRODUCT_BRAND_NAMES: Readonly<Record<SupportedLocale, string>> = brandConfig.names;
export const STATIC_PRODUCT_NAME = brandConfig.staticName;

function getDefaultDocument(): Document | undefined {
  return typeof document === "undefined" ? undefined : document;
}

function updateMetaContent(targetDocument: Document, selector: string, content: string): void {
  const meta = targetDocument.querySelector<HTMLMetaElement>(selector);
  if (meta) {
    meta.content = content;
  }
}

export function productNameForLocale(locale: unknown): string {
  return PRODUCT_BRAND_NAMES[normalizeSupportedLocale(locale)];
}

export function applyDocumentProductBrand(
  locale: unknown,
  targetDocument: Document | undefined = getDefaultDocument(),
): void {
  if (!targetDocument) {
    return;
  }

  const normalizedLocale = normalizeSupportedLocale(locale);
  const productName = PRODUCT_BRAND_NAMES[normalizedLocale];

  targetDocument.documentElement.lang = normalizedLocale;
  targetDocument.title = productName;
  updateMetaContent(targetDocument, 'meta[name="apple-mobile-web-app-title"]', productName);
  updateMetaContent(targetDocument, 'meta[property="og:title"]', productName);
}
